import { computed, inject, Injectable, signal } from '@angular/core';
import { FormService } from 'src/app/services/form.service';

@Injectable()
export class StepsService {

  stepsData = {
    rentalPointsSelection: {
      step: 1,
      id: 'rentalPointsSelection',
      label: 'rentalPointsSelection.title'
    },
    bikesSelection: {
      step: 2,
      id: 'bikesSelection',
      label: 'bikesSelection.title'
    },
    accessoriesSelection: {
      step: 3,
      id: 'accessoriesSelection',
      label: 'accessoriesSelection.title'
    },
    renterInfo: {
      step: 4,
      id: 'renterInfo',
      label: 'renterInfo.title'
    },
    termsAndConditions: {
      step: 5,
      id: 'termsAndConditions',
      label: 'termsAndConditions.title'
    },
    paymentSelection: {
      step: 6,
      id: 'paymentSelection',
      label: 'paymentSelection.title'
    },
    invoiceData: {
      step: 7,
      id: 'invoiceData',
      label: 'invoiceData.title'
    },
    bookingHandler: {
      step: 8,
      id: 'bookingHandler',
      label: 'bookingHandler.onlinePayment.title'
    },
  };

  private formService = inject(FormService);

  private _currentStep = signal<number>(1);
  readonly currentStep = computed(() => this._currentStep());

  readonly currentLabel = computed(() => this.stepsData[Object.keys(this.stepsData)[this.currentStep() - 1]].label);
  readonly currentFormId = computed(() => this.stepsData[Object.keys(this.stepsData)[this.currentStep() - 1]].id);

  readonly stepsLength = Object.keys(this.stepsData).length

  nextStepHandler() {
    if (this.currentStep() === this.stepsLength) {
      return this._currentStep.set(1);
    }
    this._currentStep.update((currentStep) => {
      if (currentStep === this.stepsData.paymentSelection.step && this.formService.form().isReservation) {
        this.stepsData.bookingHandler.label = 'bookingHandler.reservationStatus';
        return this.stepsData.bookingHandler.step;
      }
      return currentStep + 1;
    });
  }

  previousStepHandler() {
    if (this._currentStep() === 1) return;
    this._currentStep.update((currentStep) => currentStep - 1);
  }

}
